export default __webpack_public_path__ + "static/media/MarDOM2026.ebae6d63.jpg";